var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.captcha},[_c('header',{style:({ backgroundColor: _vm.color })},[_c('span',[_vm._v("滑动验证")])]),_c('main',[_c('div',{class:_vm.$style.instance,attrs:{"id":"captcha"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }